// extracted by mini-css-extract-plugin
module.exports = {"Information":"Information_Information__3R1u8"};